
<div class="poasterPopBg">
  <div class="flexRow commentContainerPop postImageContainer">
    <div class="cursor closeIconWhite" @click="$emit('closeshare')"></div>
    <div id="catImg" class="innerContainer">
      <div class="flexColumn posterContent">
        <div
          class="imgContainer"
          :style="{
            height: $attrs.height ? `${$attrs.height}px !important` : '',
          }"
        >
          <img
            :src="`${
              $attrs.book.BookPosterUrl || $attrs.book.subImg || $attrs.book.CoverUrl
            }?v=${Math.ceil(Math.random() * 100000)}`"
            crossorigin="anonymous"
            :key="`${$attrs.book.BookPosterUrl || $attrs.book.subImg || $attrs.book.CoverUrl}`"
            style="width: 100%; height: 100%; border: 0px solid #f00"
            alt
          />
        </div>
        <p class="title">{{ $attrs.book.Title }}</p>
        <div class="flexRow" v-if="$attrs.book.Author || $attrs.book.bookEditorInChief">
          <p class="author" v-if="$attrs.book.bookEditorInChief">
            <span class="editorInChief">{{ $attrs.book.bookEditorInChief }}</span>
          </p>
          <p class="author" v-else-if="$attrs.book.Author">
            <span class="authorName">{{ $attrs.book.Author }}</span>
          </p>
        </div>
      </div>
      <div class="flexColumn pt24" style="background: #fff; border-radius: 0 0 5px 5px">
        <div class="shareBottomContainer pb24">
          <img :src="shareBottomBg" class="shareBottomContainerImg" alt />
          <div class="qrCode" v-if="$attrs.shareUrl">
            <VueQr :size="70" margin="0" :text="$attrs.shareUrl"></VueQr>
          </div>
        </div>
      </div>
    </div>
    <div class="cursor flexRow bottomCloseContainer" @click="download">
      <div class="xiazaiIcon"></div>
      <div class="downloadText">下载保存</div>
    </div>
  </div>
</div>
